'use strict';

angular.module('amexReconciliationApp')
  .component('amountInputField', {
    templateUrl: 'scripts/views/components/amount-input-field.html',
    bindings: {
      value: '='
    },
    controller: function($filter, UserModel, CurrencyService) {
      var self = this;

      self.numberField = function(newVal) {
        if (arguments.length && !_.isEqual(self.value, toggleCurrencyFormat(newVal))) {
          newVal = toggleCurrencyFormat(newVal);
          self.value = validateTwoDecimalInput(newVal);
        }
        return toggleCurrencyFormat(self.value);

      };

      self.format = function() {
        var dashRegex = /[^0-9.\-]/g;
        var numberValue = toggleCurrencyFormat(self.numberField());

        if (numberValue && numberValue.trim() === '.') {
          numberValue = $filter('number')('', 2);
        } else {
          numberValue = $filter('number')(numberValue, 2).replace(dashRegex, '');
        }

        if (UserModel.getCurrencyFormat() == 'COMMA') {
          numberValue = CurrencyService.switchCommasAndPeriods(numberValue);
        }

        self.numberField(numberValue);
      };

      function validateTwoDecimalInput(newVal) {
        var regex = /[^0-9.]/g;
        var dashRegex = /[^0-9.\-]/g;
        var digitRegex = /[^0-9]/g;
        var delimiter = '.';

        var value = newVal.replace(dashRegex,'');

        var prefix = value.substr(0,1) === '-' ? '-' : '';

        var formattedNumber = value.replace(regex,'');

        var number = formattedNumber.substr(0,formattedNumber.substr(0,10).indexOf(delimiter) === -1 ? 10  : formattedNumber.indexOf(delimiter));

        var decimal = formattedNumber.indexOf(delimiter) === -1 ? '' : delimiter;

        var precision;

        if (value.indexOf(delimiter) === -1 ) {
          precision = '';
        } else {
          precision = value.substr(value.indexOf(delimiter) + 1).replace(digitRegex,'').substr(0,2);
        }

        return prefix + number + decimal + precision;
      }

      function toggleCurrencyFormat(value) {
        if (UserModel.getCurrencyFormat() == 'COMMA') {
          value = CurrencyService.switchCommasAndPeriods(value);
        }
        return value;
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/amountInputField.js
// module id = 435
// module chunks = 0